import { gql } from "@apollo/client";

export const COMPLAINT_FIELDS = gql`
  fragment complaintFields on Complaint {
    _id
    type
    priority
    status
    subject
    description
    openedByEmail
    resolutionNotes
    closedAt
    confirmedAt
    createdAt
    updatedAt
    statusHistory {
      status
      changedByEmail
      changedAt
      remark
    }
    employee {
      _id
      givenName
      surName
      passportNumber
      status
    }
    company {
      _id
      displayName
    }
  }
`;

export const GET_ALL_COMPLAINTS = gql`
  ${COMPLAINT_FIELDS}
  query GetComplaints(
    $skip: Int!
    $take: Int!
    $status: ComplainStatus
    $priority: ComplainPriority
    $type: ComplainTypes
    $employeeId: String
    $searchText: String
  ) {
    findComplaints(
      skip: $skip
      take: $take
      status: $status
      priority: $priority
      type: $type
      employeeId: $employeeId
      searchText: $searchText
    ) {
      totalCount
      complaints {
        ...complaintFields
      }
    }
  }
`;

export const GET_COMPLAINT = gql`
  ${COMPLAINT_FIELDS}
  query GetComplaint($id: String!) {
    getComplaint(id: $id) {
      ...complaintFields
    }
  }
`;
